import { render, staticRenderFns } from "./LoadingArea.vue?vue&type=template&id=22919acd"
import script from "./LoadingArea.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingArea.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports